export default "__VITE_ASSET__BMGU_QCe__"